import { render } from "./InvMarcas.vue?vue&type=template&id=c67c417e&scoped=true"
import script from "./InvMarcas.vue?vue&type=script&lang=js"
export * from "./InvMarcas.vue?vue&type=script&lang=js"

import "./InvMarcas.vue?vue&type=style&index=0&id=c67c417e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c67c417e"]])

export default __exports__